import React from "react";
import { Paystub } from "../../../messages/Paystub";
import PaystubDetailsScreen from "./PaystubDetailsScreen";
import { useMutation } from "@tanstack/react-query";
import { API } from "../../../API";
import { openExternalUrl } from "../../../external_link";
import { CaregiverPaystubPdfResponse } from "../../../messages/Payroll";
import useModal from "../../useModal";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";

type Props = {
  api: API;
  paystub: Paystub;
  onClickGoBack: () => void;
};

const PaystubDetailsActivity = (props: Props) => {
  const modal = useModal();
  const generatePaystubMutation = useMutation({
    mutationFn: () => props.api.downloadPaystub({ paystub: props.paystub }),
    onSuccess: (data: CaregiverPaystubPdfResponse) => {
      openExternalUrl(data.url);
    },
    onError: () => {
      modal.setModalAsError({
        title: translate(STRINGS.ERROR),
        message: translate(STRINGS.SOMETHING_WENT_WRONG),
      });
    },
  });
  return (
    <PaystubDetailsScreen
      paystub={props.paystub}
      onClickGoBack={props.onClickGoBack}
      onClickDownload={generatePaystubMutation.mutate}
      isLoading={generatePaystubMutation.isLoading}
    />
  );
};

export default PaystubDetailsActivity;
